import { BsShare, BsGetEnv } from 'dida-web-common'
import { activeTemplateCode } from './tools'
let URL = ''
const List = 'cid&access_token&_iadid&_iidid&key_sign&ad_position&ad_location&share'

export default (shareConfig = {}, itemTypes) => {
    if (activeTemplateCode[itemTypes]) return
    (function() {
        if (shareConfig.url) {
            URL = shareConfig.url
        } else {
            const list = List.split('&')
            let url = window.location.href
            if (url.indexOf('useHash=true') !== -1) {
                url = url.split('#')[0]
            }
            list.forEach(parameter => {
                if (URL) {
                    url = URL
                }
                var urlparts = url.split('?')
                if (urlparts.length >= 2) {
                    var prefix = encodeURIComponent(parameter) + '='
                    var pars = urlparts[1].split(/[&;]/g)
                    for (var i = pars.length; i-- > 0;) {
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1)
                    }
                    }
                    URL = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
                    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
                }
                URL = url
                return url
            })
        }
    }())
    URL.indexOf('?') > -1 ? (URL += `&share=true`) : (URL += `?share=true`)
    if (shareConfig.switch && URL) {
        // title, desc, link, imgUrl, success, fail, cancel, wx_appid, jsApiList, openTagList
        // title, desc, link, imgUrl, success, fail, cancel, wx_appid, jsApiList, openTagList
        const obj = {
            data: {
                title: shareConfig.title,
                desc: shareConfig.desc,
                imgUrl: shareConfig.imgUrl,
                link: URL
                // showChannel: shareConfig.showChannel
            },
            shareByAppMinPg: {
                enable: shareConfig.appShareSwitch
                // channel:
            },
            shareByMinipg: {
                enable: true,
                link: '/pagesWebView/webViewActivity/webViewActivity?baseUrl=' + encodeURIComponent(URL),
                imgUrl: shareConfig.imgUrl
            },
            shareByWx: {
                enable: true
            },
            shareByDingtalk: {
                enable: true
            }
        }
        if (shareConfig.appShareSwitch && shareConfig.showChannel) {
            obj.data.showChannel = shareConfig.showChannel
        }
        if (shareConfig.miniPgShareSwitch) {
            const miniPgShare = {
                minipgThumbnail: shareConfig.imgUrl,
                minipgTitle: shareConfig.title,
                minipgDes: shareConfig.desc,
                minipgLink: '/pagesWebView/webViewActivity/webViewActivity?baseUrl=' + encodeURIComponent(URL),
                minipgWithShareTicket: true,
                minipgType: BsGetEnv.isEnvOnline ? 0 : 2, // 体验版
                minipgUserName: 'gh_49e3fa80623f'
            }
            obj.data = {
                ...obj.data,
                ...miniPgShare
            }
        }
        // if (!shareConfig.appShareSwitch) {
        //     obj.shareByApp.enable = false
        // }
        new BsShare(obj)
    }
}
